import React from "react";
import "../styles/Resultados.scss";

const METRICS = [
  { value: "Más", label: "prospectos", hint: "Campañas + contenido" },
  { value: "Mejor", label: "conversión", hint: "Landing + CTA" },
  { value: "Más", label: "confianza", hint: "Imagen profesional" },
  { value: "Menos", label: "tareas", hint: "Automatización n8n" },
];

export default function Resultados() {
  return (
    <section className="ovit-resultados" id="resultados">
      <div className="ovit-resultados__bg" aria-hidden="true">
        <div className="ovit-resultados__grid" />
        <div className="ovit-resultados__glow ovit-resultados__glow--1" />
        <div className="ovit-resultados__glow ovit-resultados__glow--2" />
      </div>

      <div className="ovit-resultados__container">
        <header className="ovit-resultados__header">
          <h2 className="ovit-resultados__title">
            Resultados <span>que Importan</span>
          </h2>
          <p className="ovit-resultados__subtitle">
            Convertimos tu presencia digital en un sistema que atrae, responde y convierte.
          </p>
        </header>

        <div className="ovit-metrics">
          {METRICS.map((m) => (
            <div className="ovit-metric" key={m.label}>
              <div className="ovit-metric__value">{m.value}</div>
              <div className="ovit-metric__text">
                <div className="ovit-metric__label">{m.label}</div>
                <div className="ovit-metric__hint">{m.hint}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="ovit-resultados__cta">
          <a className="ovit-resultados__btn" href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20iniciar%20mi%20estrategia%20digital.%20Me%20gustar%C3%ADa%20recibir%20una%20propuesta." target="_blank" rel="noopener noreferrer">
            Quiero más información
          </a>
        </div>
      </div>
    </section>
  );
}
